import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { svgIcons } from '../../../../style/fonts/SvgIcons'
import { Tooltip as ReactTooltip } from "react-tooltip";

const ClientNotes = ({ handleEditNotes }: any) => {

    return (
        <>
            <ReactTooltip
                id="my-tooltip-1"
                place="top"
                content="copy to another Project"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />
            <ReactTooltip
                id="my-tooltip-2"
                place="top"
                content="Strikeout"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />
            <ReactTooltip
                id="my-tooltip-3"
                place="top"
                content="Public"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />
            <ReactTooltip
                id="my-tooltip-4"
                place="top"
                content="Private"
                style={{ color: "#B11F28", backgroundColor: '#F8E9EA' }}
            />

            <div className="task-wrapper mt-3">
                <Link
                    to="#"
                    className="task-accordion"
                    data-bs-toggle="collapse"
                    data-bs-target="#yesterday"
                    onClick={(e) => e.preventDefault()}
                >
                    <div className="noti-content mt-3">
                        <ul className="notification-list">
                            <li className="notification-message">
                                <Link to='#' onClick={(e) => e.preventDefault()}>
                                    <div className="d-flex gap-2 align-items-center">
                                        <h6 className=""><span className="mb-0 icon-style me-2">{svgIcons.NotesIcon}</span></h6>
                                        <div className='task-info'>
                                            <p className='mb-0'><h6>Client Note: Appreciation For Attic Conversion Progress</h6></p>
                                            <p className='mb-0'><h6 className='text-muted'>created by</h6>
                                            </p>
                                            <p className='mb-0'><h6>David Lee </h6></p>
                                            <p className='text-muted mb-0'><h6 className='text-muted'>at</h6></p>
                                            <p className='mb-0'><h6>9/29/2024 03:36:32 PM</h6></p>
                                            <div className='' onClick={() => handleEditNotes()}>
                                                {svgIcons.updateIcon}
                                            </div>
                                            {/* <div data-tooltip-id="my-tooltip-1" className='ms-2'>
                                                {svgIcons.CopyIcon}
                                            </div> */}
                                            <div data-tooltip-id="my-tooltip-2" className='ms-2'>
                                                {svgIcons.strikeIcon}
                                            </div>
                                            <div data-tooltip-id="my-tooltip-3" className='ms-2'>
                                                {svgIcons.GlobalIcon}
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </Link>
                <div
                    className="tasks-activity tasks collapse show"
                    id="yesterday"
                >
                    <ul>
                        <li>
                           <p>The customers are very pleased with the progress of their attic conversion. They express their satisfaction with the recent space planning and insulation work and are excited about the upcoming guest room and office area creation. Their positive feedback reflects their confidence in the project team's capabilities and dedication to building high-quality results.</p>
                        </li>
                    </ul>
                </div>
                <hr/>
                <div className='mt-3'>
                    <Link
                        to="#"
                        className="task-accordion"
                        data-bs-toggle="collapse"
                        data-bs-target="#yesterday1"
                        onClick={(e) => e.preventDefault()}
                    >
                        <div className="noti-content mt-3">
                            <ul className="notification-list">
                                <li className="notification-message">
                                    <Link to='#' onClick={(e) => e.preventDefault()}>
                                        <div className="d-flex gap-2 align-items-center">
                                            <h6 className=""><span className="mb-0 icon-style me-2">{svgIcons.NotesIcon}</span></h6>
                                            <div className='task-info'>
                                                <p className='mb-0'><h6>Client Note : Appreciation For project progress</h6></p>
                                                <p className='mb-0'><h6 className='text-muted'>created by</h6>
                                                </p>
                                                <p className='mb-0'><h6>Me</h6></p>
                                                <p className='text-muted mb-0'><h6 className='text-muted'>at</h6></p>
                                                <p className='mb-0'><h6>9/29/2024 03:36:32 PM</h6></p>
                                                <div className='' onClick={() => handleEditNotes()}>
                                                    {svgIcons.updateIcon}
                                                </div>
                                                {/* <div className='ms-2' data-tooltip-id="my-tooltip-1">
                                                    {svgIcons.CopyIcon}
                                                </div> */}
                                                <div className='ms-2' data-tooltip-id="my-tooltip-2">
                                                    {svgIcons.strikeIcon}
                                                </div>
                                                <div className='ms-2' data-tooltip-id="my-tooltip-4">
                                                    {svgIcons.GlobalIcon}
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </Link>
                    <div
                        className="tasks-activity tasks collapse"
                        id="yesterday1"
                    >
                        <ul>
                            <li>
                                The customers are very pleased with the progress of their project. they express their satisfaction with recent project coordination committee (PCC) meetings, and also they excited about upcoming projects renovations. their positive feedback reflects itheir confidence in the projects  team 's capabilities and dedication to build high quality results.
                            </li>
                        </ul>
                    </div>
                </div>
                <hr/>
                <div className='mt-3'>
                    <Link
                        to="#"
                        className="task-accordion"
                        data-bs-toggle="collapse"
                        data-bs-target="#yesterday2"
                        onClick={(e) => e.preventDefault()}
                    >
                        <div className="noti-content mt-3">
                            <ul className="notification-list">
                                <li className="notification-message">
                                    <Link to='#' onClick={(e) => e.preventDefault()}>
                                        <div className="d-flex gap-2 align-items-center">
                                            <h6 className=""><span className="mb-0 icon-style me-2">{svgIcons.NotesIcon}</span></h6>
                                            <div className='task-info'>
                                                <p className='mb-0'><h6>Client Note: Appreciation For Home Theater Installation Progress</h6></p>
                                                <p className='mb-0'><h6 className='text-muted'>created by</h6>
                                                </p>
                                                <p className='mb-0'><h6>Olivia Thomas</h6></p>
                                                <p className='text-muted mb-0'><h6 className='text-muted'>at</h6></p>
                                                <p className='mb-0'><h6>9/29/2024 03:36:32 PM</h6></p>
                                                <div className='' onClick={() => handleEditNotes()}>
                                                    {svgIcons.updateIcon}
                                                </div>
                                                <div className='ms-2'>
                                                    {svgIcons.CopyIcon}
                                                </div>
                                                <div className='ms-2'>
                                                    {svgIcons.strikeIcon}
                                                </div>
                                                <div className='ms-2'>
                                                    {svgIcons.GlobalIcon}
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </Link>
                    <div
                        className="tasks-activity tasks collapse"
                        id="yesterday2"
                    >
                        <ul>
                            <li>
                            <p className="noti-details mb-0">
                                Addenda Nbr: FLD-23006104
                            </p>
                            <p>
                                Status: From Pending to Reviewed
                            </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <hr/>
                <div className='mt-3'>
                    <Link
                        to="#"
                        className="task-accordion"
                        data-bs-toggle="collapse"
                        data-bs-target="#yesterday3"
                        onClick={(e) => e.preventDefault()}
                    >
                        <div className="noti-content mt-3">
                            <ul className="notification-list">
                                <li className="notification-message">
                                    <Link to='#' onClick={(e) => e.preventDefault()}>
                                        <div className="d-flex gap-2 align-items-center">
                                            <h6 className=""><span className="mb-0 icon-style me-2">{svgIcons.NotesIcon}</span></h6>
                                            <div className='task-info'>
                                                <p className='mb-0'><h6>Client Note: Appreciation For Garage Conversion Progress Created By </h6></p>
                                                <p className='mb-0'><h6 className='text-muted'>created by</h6>
                                                </p>
                                                <p className='mb-0'><h6>Me</h6></p>
                                                <p className='text-muted mb-0'><h6 className='text-muted'>at</h6></p>
                                                <p className='mb-0'><h6>9/29/2024 03:36:32 PM</h6></p>
                                                <div className='' onClick={() => handleEditNotes()}>
                                                    {svgIcons.updateIcon}
                                                </div>
                                                <div className='ms-2'>
                                                    {svgIcons.CopyIcon}
                                                </div>
                                                <div className='ms-2'>
                                                    {svgIcons.strikeIcon}
                                                </div>
                                                <div className='ms-2'>
                                                    {svgIcons.GlobalIcon}
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </Link>
                    <div
                        className="tasks-activity tasks collapse"
                        id="yesterday3"
                    >
                        <ul>
                            <li>
                                <p> Status: Inprogress</p><p>
                                     Details: Redlines for the kitchen and bath components have been picked up and are currently under review. Once the review is complete, a comprehensive set of redlines will be created for David, the project manager, to ensure accuracy and compliance with project specifications.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </>
    )
}

export default ClientNotes